import React from 'react'
import { Modal } from 'react-bootstrap'
import { FilePathName } from '../../../Context/api'

const ViewTestReport = ({ methods, data }) => {
    const { openModal } = data
    const { handleClosedModal } = methods
    return (
        <>
            <Modal size={`${openModal?.data?.test?.split('.')?.pop() === "pdf" ? "xl" : "md"}`} show={openModal?.data?.test && openModal?.showTestReport} onHide={() => { handleClosedModal("showTestReport") }} centered>
                <Modal.Body className="p-0" style={{ height: ` ${openModal?.data?.test?.split('.')?.pop() === "pdf" ? "600px" : "400px"} ` }}>
                    {
                        openModal?.data?.test?.split('.')?.pop() === "pdf" ? <iframe src={FilePathName + openModal?.data?.test} title={FilePathName + openModal?.data?.test} style={{ width: '100%', height: '100%', }} /> :
                            <img style={{ width: "100%", height: "100%", objectFit: "cover" }} src={FilePathName + openModal?.data?.test} alt="" />
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ViewTestReport
